import {
  ICapTableFilters,
  ICapTableMappingData,
  ICapTableSummaryData,
} from '@common/interfaces/capTable'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import * as actions from './actions'

export default combineReducers({
  capTableFilters: createLoadingDataReducer<ICapTableFilters>([
    actions.LIST_CAPTABLE_FILTERS_REQUEST,
  ]),
  capTableMapping: createLoadingDataReducer<ICapTableMappingData>(
    [actions.LIST_MAPPING_REQUEST],
    [actions.UPDATE_CAP_TABLE_DETAILS_REQUEST],
    true,
    [],
    true,
  ),

  capTableSummary: createLoadingDataReducer<ICapTableSummaryData>([actions.LIST_CAPTABLE_REQUEST]),
})
